import {
  getGoogleAnalyticsId,
  track,
} from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import { render } from 'datocms-structured-text-to-plain-text';

export const getTableOfContentHeading = (
  doc: any,
): { title: string; subheadings: Array<{ title: string }> }[] => {
  const headings: any = [];
  let heading: any = undefined;
  // Search in all paragraph blocks
  for (let i = 0; i < doc.blocks.length; i++) {
    const block = doc.blocks[i];
    if (block.__typename === 'DatoCmsParagraph') {
      const textNodes = block.text.value.document.children;
      // Search all the h2 and h3 nodes in a paragraph
      for (let j = 0; j < textNodes.length; j++) {
        if (textNodes[j].type === 'heading') {
          if (textNodes[j].level === 2) {
            // check that previous heading exists
            if (heading) {
              // Add previous heading to the list
              headings.push(heading);
              heading = { title: render(textNodes[j]), subheadings: [] };
            } else {
              heading = { title: render(textNodes[j]), subheadings: [] };
            }
          } else if (textNodes[j].level === 3 && heading !== undefined) {
            // h3s are included only if they are preceded by a h2 (heading is not undefined)
            heading.subheadings.push({ title: render(textNodes[j]) });
          }
        }
      }
    }
  }
  if (heading) headings.push(heading);

  return headings;
};

export const scrollToHeading = (title?: string) => {
  if (!title) return '';
  const headingId = title?.replace(/\W+/g, '-');
  return `#${headingId}`;
};

export const handleHeadingChange = (
  title: string,
  setActiveHeadingTitle: any,
) => {
  if (typeof window !== 'undefined') {
    setActiveHeadingTitle(title);

    track({
      gtm: {
        event: 'Toggle Interaction',
        properties: {
          componentName: 'MinifiedTableOfContent',
          toggleLabel: `${title}`,
          gaClientID: getGoogleAnalyticsId(),
        },
      },
    });

    window.location.hash = '';
    window.location.hash = scrollToHeading(title);
  }
};

export const handleActiveHeading = (
  headingElementsRef: any,
  activeHeadingTitle: string | undefined,
  setActiveHeadingTitle: any,
): void => {
  if (typeof window === 'undefined') return;
  const windowHeight = window.innerHeight;
  const headingArray = Object.values(headingElementsRef.current);
  const h2Array: any = headingArray.filter(
    (heading: any) => heading.tagName === 'H2',
  );

  for (let i = 0; i < h2Array.length; i++) {
    const heading = h2Array[i];
    const rect = heading.getBoundingClientRect();
    const fromViewportBottom = windowHeight - rect.top;

    if (
      window.location.hash === scrollToHeading(activeHeadingTitle) &&
      h2Array?.[0]?.getBoundingClientRect()?.top > 0
    )
      break;
    if (
      (fromViewportBottom >= 250 && fromViewportBottom <= windowHeight) ||
      (rect.top <= 0 && rect.bottom >= 0)
    ) {
      if (heading.textContent) {
        setActiveHeadingTitle(heading.textContent.trim());
        break;
      }
    }
  }
};

export const handleScroll = (sidebarRef: any, setIsMinified: any) => {
  if (typeof window === 'undefined') return;
  const scrollY = window.scrollY;
  const tableBoundaries = sidebarRef.current?.getBoundingClientRect();
  const tableOfContentY = tableBoundaries?.top;
  const tableOfContentHeight = tableBoundaries?.height;

  if (tableOfContentY !== undefined && tableOfContentHeight !== undefined) {
    if (scrollY > tableOfContentY + 200) {
      setIsMinified(true);
    } else if (scrollY < tableOfContentY) {
      setIsMinified(false);
    }
  }
};
